import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Tras un despliegue, los chunks viejos dejan de existir: recargar una sola vez en lugar de dejar pantallas (o tickets) en blanco.
window.addEventListener("error", (e) => {
  const msg = String(e?.message || e?.error?.message || "");
  if (/ChunkLoadError|Loading chunk|Loading CSS chunk/i.test(msg) && !sessionStorage.getItem("rubipos_reload_chunk")) { sessionStorage.setItem("rubipos_reload_chunk", "1"); window.location.reload(); }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = String(e?.reason?.message || e?.reason || "");
  if (/ChunkLoadError|Loading chunk/i.test(msg) && !sessionStorage.getItem("rubipos_reload_chunk")) { sessionStorage.setItem("rubipos_reload_chunk", "1"); window.location.reload(); }
});
window.addEventListener("load", () => setTimeout(() => sessionStorage.removeItem("rubipos_reload_chunk"), 10000));


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// App instalable (PWA): ícono en el escritorio y arranque sin navegador visible; el POS y etiquetas operan sin conexión
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); window.__rubiposInstall = e; window.dispatchEvent(new Event("rubipos-instalable")); });
